import { useTranslation } from "react-i18next";
import { InputFormControl } from "@hawkins/forms";

import { TranslationNamespace } from "../../types";
import { Repeater } from "./Repeater";
import { Divider } from "@hawkins/components";

type EmailRepeaterProps = {
  methods: any;
  disabled?: boolean;
};

export function EmailRepeater({ methods, disabled = false }: EmailRepeaterProps) {
  const { t } = useTranslation(TranslationNamespace.LEP);

  return (
    <>
      <Repeater
        name="memberIdPayload.emailAddresses"
        componentGenerator={(idx) => (
          <InputFormControl
            key={`email-${idx}`}
            name={`memberIdPayload.emailAddresses.${idx}`}
            label={t("field_email_address")}
            requirementType="required-star"
            style={{ width: 'clamp(25vw, 50vw, 500px)' }}
            data-testid={`email-input-${idx}`}
          />
        )}
        defaultValueGenerator={() => ''}
        removeText={t('button_remove')}
        addText={t('button_add')}
        methods={methods}
        disabled={disabled}
      />
      <Divider />
    </>
  );
}